import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import Spinner from "./Spinner.js";

import { jwt } from "../utils/index.js";

import Sidebar from "./Sidebar.js";
import useAuthorizationStyles from "./styles/Authorization.js";

const maybeSetToken = (Component) => (props) => {
    const { search } = useLocation();
    const { token } = queryString.parse(search);
    if (token) jwt.setToken(token);
    return <Component {...props} />;
};

const AdminOnly = ({ c }) => {
    const [isSmall, setIsSmall] = useState(window.innerWidth < 900);
    const location = useLocation();
    const classes = useAuthorizationStyles();
    const [isLoading, setIsLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        const checkAdminStatus = async () => {
            const adminStatus = await jwt.isAdmin();
            setIsAdmin(adminStatus);
            setLoading(false);
        };
        checkAdminStatus();
        setIsLoading(false);
    }, []);

    useEffect(() => {
        const onResize = () => setIsSmall(window.innerWidth < 900);
        window.addEventListener("resize", onResize);

        return () => window.removeEventListener("resize", onResize);
    }, []);

    if (loading) {
        return <Spinner open={isLoading}/>;
    }

    return (isAdmin && jwt.isAuthenticated())
        ? (
            <div className={classes.main}>
                <Sidebar isSmall={isSmall} />
                <div className={classes.mainBox} style={{ width: (isSmall) ? "calc(100% - 50px)" : "calc(100% - 200px)", marginLeft: (isSmall) ? "50px" : "250px", backgroundColor: (window.location.pathname !== '/home') ? "white" : null }}>
                    <div className="header-container">
                        {c}
                    </div>
                </div>
            </div>
        )
        : <Navigate replace to="/" state={{ from: location }} />;
};

AdminOnly.propTypes = { c: PropTypes.node.isRequired };
AdminOnly.whyDidYouRender = true;

export default maybeSetToken(AdminOnly);

